export default {
  "content": "<path d=\"M248 64C146.39 64 64 146.39 64 248s82.39 184 184 184 184-82.39 184-184S349.61 64 248 64z\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M220 220h32v116M208 340h88\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M248 130a26 26 0 1026 26 26 26 0 00-26-26z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};